import type { AvatarComponent } from '@rainbow-me/rainbowkit'

import WanIcon from '@/assets/Wanchain.png'

export const CustomAvatar: AvatarComponent = ({ size }) => {
  return (
    <img
      src={WanIcon}
      width={size}
      height={size}
      style={{ borderRadius: 999 }}
      alt="Chain Logo"
    />
  )
}
